<featured-products-row-embed
  [products]="products"
  [titleTag]="titleTag"
  [showAiMessage]="showAiMessage">
</featured-products-row-embed>
